import React from "react";

import {
  IgButton,
  IgPaper,
  IgTableWrapper,
  IgTypography,
} from "@intelligems/ig-theme";
import {
  OrganizationSummarySubscriptionDto,
  OrgShopIdDto,
} from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { useCancelOrganizationSubscriptions } from "@src/api/organization-subscriptions/admin-cancel-organization-subscriptions";
import { AreYouSure } from "@src/components/Popover/AreYouSure";
import { LegacyBadge } from "@src/features/admin/components/Icons/LegacyBadge";
import { DeprecatedSubscriptionsTable } from "@src/features/admin/pages/overview/components/Tables/DeprecatedSubscriptionsTable.tsx/DeprecatedSubscriptionsTable";

interface LegacySubscriptionPaneProps {
  legacySubscriptions: OrganizationSummarySubscriptionDto[];
  org: OrgShopIdDto;
}

export const LegacySubscriptionsPanel = ({
  org,
  legacySubscriptions,
}: LegacySubscriptionPaneProps) => {
  const theme = useTheme();
  const cancelOrgSubs = useCancelOrganizationSubscriptions(org);
  return (
    <IgPaper
      sx={{
        backgroundColor: theme.igBackgroundColors.baseLightMid,
        padding: "10px 20px 20px 20px",
      }}
    >
      <Grid
        container
        item
        direction={"column"}
        justifyContent={"start"}
        rowSpacing={1}
      >
        <Grid
          container
          item
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item>
            <LegacyBadge />
          </Grid>
        </Grid>
        <IgTableWrapper minHeight={"100px"} height={null}>
          <DeprecatedSubscriptionsTable subscriptions={legacySubscriptions} />
        </IgTableWrapper>
        <Grid item textAlign={"end"}>
          <AreYouSure
            enabled={true}
            keyId={"cancel-old-subs"}
            buttonText={"Cancel"}
            isLoading={cancelOrgSubs.isPending}
            onYesClick={() => cancelOrgSubs.mutate({})}
            message={
              <IgTypography variant={"body2"}>
                This will mark all legacy subscriptions as cancelled + cancel
                any old{" "}
                <IgTypography variant={"body2"} sx={{ fontWeight: 600 }}>
                  Shopify
                </IgTypography>{" "}
                subscriptions.
                <br /> Old{" "}
                <IgTypography variant={"body2"} sx={{ fontWeight: 600 }}>
                  Stripe
                </IgTypography>{" "}
                subscriptions must be manually cancelled in the Stripe
                Dashboard.
              </IgTypography>
            }
            yesMessage={"Continue"}
          >
            <IgButton
              variant={"contained"}
              color={"error"}
              loading={cancelOrgSubs.isPending}
            >
              Cancel Legacy Subscriptions
            </IgButton>
          </AreYouSure>
        </Grid>
      </Grid>
    </IgPaper>
  );
};
